import React, { useState } from "react";
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Box,
  Typography,
} from "@mui/material";
import { SaveButton, CancelButton } from "../../common/Buttons";

function EditQtyDialog({
  rowData,
  itemData,
  onClose,
  handleUpdateOrder,
  openSnackbar,
}) {
  const [qty, setQty] = useState(rowData?.qty || 0);

  // 제품명 찾기
  const matchedItem = itemData?.find(
    (item) => item.item_id === rowData?.item_id
  );

  const handleSave = () => {
    const obj = {
      order_name: rowData.order_name,
      color: rowData.color,
      item_id: rowData.item_id,
      qty: Number(qty),
      start_date: rowData.start_date, // ✅ 기존 start_date 유지 (필수값)
      due_date: rowData.due_date,
      priority: rowData.order_priority,
      order_id: rowData.order_id,
    };

    console.log("EditQtyDialog handleSave obj:", obj); // ✅ 디버깅용

    handleUpdateOrder({ values: obj, table: null });
    openSnackbar("수량이 수정되었습니다.", "success");
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <>
      <DialogTitle
        variant="h6"
        sx={{ fontSize: "18px !important", color: "#111" }}
      >
        생산수량 수정
      </DialogTitle>
      <DialogContent
        sx={{ display: "flex", flexDirection: "column", gap: "1.5rem", pt: 2 }}
      >
        <Box>
          <Typography variant="body2" color="text.secondary">
            생산 지시 ID
          </Typography>
          <Typography variant="body1" fontWeight={500}>
            {rowData?.order_name || "-"}
          </Typography>
        </Box>

        <Box>
          <Typography variant="body2" color="text.secondary">
            제품명
          </Typography>
          <Typography variant="body1" fontWeight={500}>
            {matchedItem?.item_name || "-"}
          </Typography>
        </Box>

        <TextField
          label="수량"
          type="number"
          value={qty}
          onChange={(e) => setQty(e.target.value)}
          fullWidth
          inputProps={{ min: 0 }}
          autoFocus
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <SaveButton onClick={handleSave} disabled={!qty || qty <= 0} />
        <CancelButton onClick={handleCancel} />
      </DialogActions>
    </>
  );
}

export default EditQtyDialog;
